/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import _map from 'lodash/map'
import _forEach from 'lodash/forEach'
import {useSelector} from 'react-redux'
import {injectMerchantChannelMock} from './mock/merchantChannelMock'

export enum RechargeEnum {
  主播钱包 = 0,
  普通充值 = 1,
  币商充值 = 2,
}

export enum ChannelStatusEnum {
  不生效 = 0,
  生效 = 1,
}

export enum ChannelTypeEnum {
  官方 = 0,
  周卡 = 1,
  华为 = 2,
  第三方 = 3,
  薪资转金币 = 4,
  币商 = 5,
}

export interface MerchantUserItem {
  mid: number
  show_id: string
  name: string
  avatar: string
  status: number
  flag_url: string
  user_privilege_st?: {
    medals?: Array<{
      id: number
      icon?: string
      dmk_icon?: string
      icon_v2?: string
    }>
  }
}

export interface RedirectInfo {
  redirect_url: string
  redirect_param: {[key: string]: string}
  redirect_method: 'get' | 'post'
}

export interface ProductsListInterface {
  list: Array<any>
  coins: number
  last_coins_stage: number
  tickets: number
  status: number
  exchange_cnt: number
  remain_tm: number
  is_recharged: number
  before_recharged: number
  is_ra_customer: boolean
  exchange_tickets_ratio: number
  countries: Array<{
    code: number
    name: string
    flag: string
  }>
  default_country: {
    code: number
    name: string
    flag: string
  }
  is_union: number // 是否是公会主播
  is_first_recharge: boolean
  baseInfo?: {
    mid: number //	用户mid
    show_id: string //	用户展示ID
    avatar_url: string //	头像URL
    name: string // 用户昵称
    region_code: number
  }
  is_audit_ver?: boolean // 由服务端下发，不写入 initialState
  is_white_tag?: boolean
  has_third_pay?: boolean
  has_week_card: boolean
  third_party_high_potential_info?: {
    has_third_party_high_potential?: boolean // 是否是三方充值高潜用户
    show_activity?: boolean // 是否展示活动
    can_receive_award?: number // 可以领取奖励数量
  }
}

export enum LimitEnum {
  固定值 = 1,
  直播比例 = 2,
  直播流转比例 = 3,
}

export interface ProductItem {
  product_id: string
  price: number
  coins: number
  currency: string
}

export interface RcGuideInfo {
  show_popup: boolean
  title: string
  content: string
  button_text: string
}

export interface PendantUbData {
  is_show: boolean
  icon: string
  jump_url: string
  tg: number
  ep: number
}

interface initialStateType {
  wallet?: Partial<ProductsListInterface>
  agency?: any
  base?: {
    showGuide: boolean
    useNew: boolean
    showFirstRechargeGiftPack: boolean
    rcGuide?: RcGuideInfo
  }
  recharge?: {
    wallet_fr_banner_bg_icon?: string
    wallet_fr_banner_price_discount_icon?: string
  }
  trade_info?: {
    coins?: number
    country?: number
  }
  vipRechargeGift?: PendantUbData | null
}
const initialState: initialStateType = {}
const initData: initialStateType = {
  wallet: {
    list: [],
    last_coins_stage: 0,
    coins: 0,
    tickets: 0,
    status: 0,
    exchange_cnt: 0,
    remain_tm: 0,
    is_recharged: 0,
    before_recharged: 0,
    is_ra_customer: false,
    exchange_tickets_ratio: 0,
    countries: [],
    default_country: {
      code: 0,
      name: '',
      flag: '',
    },
    is_union: 0, // 是否是公会主播
    is_first_recharge: false,
    has_week_card: false,
  },
  agency: {
    banner_list: [],
  },
  base: {
    showGuide: false,
    useNew: false,
    showFirstRechargeGiftPack: false,
    rcGuide: {
      show_popup: false,
      title: '',
      content: '',
      button_text: '',
    },
  },
  recharge: {},
  trade_info: {},
}

export const get_banners = createAsyncThunk(
  'Saada/SaadaPurse/get_banners',
  async (params, store: any) => {
    const resp = await http.post('/live/misc/get_banners', {
      ...store.getState().env.deviceinfo,
      banner_type: 1, // 获取banner
    })
    return resp.data.data.banner_list || []
  }
)
export const get_recharge_agency_list = createAsyncThunk(
  'Saada/SaadaPurse/get_recharge_agency_list',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/get_recharge_agency_list', {
      ...store.getState().env.deviceinfo,
      ...params,
      offset: 0,
      limit: 10,
    })
    return resp.data.data
  }
)

export const createRechargeOrderV2 = createAsyncThunk(
  'Saada/SaadaPurse/createRechargeOrderV2',
  async (
    params: {
      product_id: string
      pay_method_id: number
      from: string
      code: number
      source: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/pay/create_order_h5_v2',
      {
        ...store.getState().env.deviceinfo,
        mid: store.getState().env.deviceinfo.h_m,
        ...params,
      },
      {
        xcHideLog: true,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// [获取商品列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=161226673
export const getProductsList = createAsyncThunk(
  'Saada/SaadaPurse/getProductsList',
  async (param: any = {}, store: any) => {
    const dev = store.getState().env.deviceinfo
    const resp = await http.post('/live/pay/get_products_list_v2', {
      ...dev,
      ...param,
      before_recharged: 1,
    })
    return {...resp.data.data}
  }
)

export const getRechargeBonus = createAsyncThunk(
  'Saada/SaadaPurse/getRechargeBonus',
  async (arg, store: any) => {
    const resp = await http.post('/live/activity/recharge_bonus', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
    })
    return resp.data
  }
)
// [web通过mid获取用户信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=96438988
export const simpleMemberByMid = createAsyncThunk(
  'Saada/SaadaPurse/simpleMemberByMid',
  async (arg, store: any) => {
    const resp = await http.post('/live/account/simple_member_by_mid', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
    })
    return resp.data.data
  }
)

// 获取首充的banner http://wiki.xunlei.cn/pages/viewpage.action?pageId=90608233
export const get_recharge_count_down = createAsyncThunk(
  'Saada/SaadaPurse/live/activity/get_recharge_count_down',
  async (any: any, store: any) => {
    const resp = await http.post(
      '/live/activity/get_recharge_count_down',
      {
        ...any,
        ...store.getState().env.deviceinfo,
      },
      {store}
    )
    return resp.data.data
  }
)

export const send_recharge_page_of_h5_event = createAsyncThunk(
  'Saada/SaadaPurse/send_recharge_page_of_h5_event',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/merchant/send_recharge_page_of_h5_event',
      params,
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const first_recharge_gift = createAsyncThunk(
  'Saada/SaadaPurse/first_recharge_gift',
  async (params: any, store: any) => {
    // return {
    //   eligible: true,
    //   gift_status: 1, // 1（可领取）、2（已领取）、3（已失效）
    // }
    const resp = await http.post('/live/merchant/first_recharge_gift', params, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=179487792
export const get_user_trade_info = createAsyncThunk(
  'Saada/SaadaPurse/get_user_trade_info',
  async (params, store: any) => {
    const resp = await http.post('/live/pay/get_user_trade_info', params, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const rc_guide_check = createAsyncThunk(
  'Saada/SaadaPurse/rc_guide_check',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/merchant/rc_guide_check',
      {
        ...store.getState().env.deviceinfo,
        ...params,
      },
      {store}
    )
    return resp.data.data
  }
)

export const cb_pendant = createAsyncThunk(
  'Saada/SaadaPurse/cb_pendant',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/cb_pendant',
      {
        ...store.getState().env.deviceinfo,
        ...params,
        type: 1,
      },
      {store}
    )
    return resp.data.data
  }
)

export const SaadaPurseSlice = createSlice({
  name: 'SaadaPurse',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    updateShowGuide: (state, action: PayloadAction<boolean>) => {
      Object.assign(state.base, {
        showGuide: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_user_trade_info.fulfilled, (state, action) => {
      Object.assign(state.trade_info, action.payload)
    })

    builder.addCase(getProductsList.fulfilled, (state, action) => {
      const res = injectMerchantChannelMock(action.payload)
      const list = _map(res?.list, (item) => {
        return {
          ...item,
          // 列表里的currency和ThirdPartyPaySt里不一致时，用列表里的currency覆盖ThirdPartyPaySt的currency
          list: _map(item?.list, (li: any) => {
            if (li?.currency !== item?.currency) {
              li.currency = item.currency
            }
            return li
          }),
        }
      })
      // 防止已经保存的数据被完全清除
      Object.assign(state, {wallet: {...res, list}})
    })

    builder.addCase(simpleMemberByMid.fulfilled, (state, action) => {
      Object.assign(state.wallet, {
        baseInfo: action.payload,
      })
    })
    builder.addCase(get_banners.fulfilled, (state, action) => {
      Object.assign(state.agency, {
        banner_list: action.payload,
      })
    })

    builder.addCase(get_recharge_count_down.fulfilled, (state, action) => {
      Object.assign(state.recharge, {
        ...action.payload,
      })
    })
    builder.addCase(first_recharge_gift.fulfilled, (state, action) => {
      const {eligible, gift_status} = action.payload
      Object.assign(state.base, {
        showFirstRechargeGiftPack: eligible && gift_status === 1,
      })
    })
    builder.addCase(rc_guide_check.fulfilled, (state, action) => {
      const {
        show_popup,
        title = '',
        content = '',
        button_text = '',
      } = action.payload || {}
      Object.assign(state.base, {
        rcGuide: {
          show_popup: Boolean(show_popup),
          title,
          content,
          button_text,
        },
      })
    })
    builder.addCase(cb_pendant.fulfilled, (state, action) => {
      Object.assign(state, {
        vipRechargeGift: action.payload?.ub ?? null,
      })
    })
  },
})
export default SaadaPurseSlice.reducer
export const SaadaPurseAction = SaadaPurseSlice.actions

export const useSaadaPurseState = () => {
  const data = useSelector((state) => {
    return state.Animal_Puma
  })
  return data
}
